import {useIntl} from 'react-intl'
import {
    VALIDATE_EMAIL_PATTERN,
    GENERAL_FORM_VALIDATION_MESSAGES as generalMessages
} from '../../constants'

export default function useGiftFields({
    form: {
        control,
        formState: {errors}
    }
}) {
    const {formatMessage} = useIntl()
    const labelGiftMessage = formatMessage({
        defaultMessage: 'Enter your message here (optional):',
        id: 'gift_msg.input.msg.label'
    })

    const labelGiftFrom = formatMessage({
        defaultMessage: 'This gift is from:',
        id: 'gift_msg.input.from.label'
    })

    const labelRecipientName = formatMessage({
        defaultMessage: 'Recipient’s name (optional):',
        id: 'gift_msg.input.recipient.name.label'
    })

    const labelRecipientEmail = formatMessage({
        defaultMessage: 'Recipient’s email (optional):',
        id: 'gift_msg.input.recipient.email.label'
    })

    const invalidEmailMessage = formatMessage({
        defaultMessage: 'Please enter a valid email address.',
        id: 'use_profile_fields.error.required_email'
    })

    return {
        giftMessage: {
            name: `giftMessage`,
            label: labelGiftMessage,
            placeholder: formatMessage({
                defaultMessage: 'Enter your message here',
                id: 'gift_msg.input.msg.placeholder'
            }),
            type: 'textarea',
            defaultValue: '',
            rules: {
                maxLength: {
                    message: formatMessage(generalMessages.maxLength, {
                        label: labelGiftMessage,
                        n: 160
                    }),
                    value: 160
                }
            },
            error: errors[`giftMessage`],
            inputProps: {
                autoComplete: 'off'
            },
            control,
            inputCounterVisible: true,
            maxLength: 160
        },
        giftFrom: {
            name: `giftFrom`,
            label: labelGiftFrom,
            placeholder: formatMessage({
                defaultMessage: 'Enter your name',
                id: 'gift_msg.input.from.placeholder'
            }),
            type: 'text',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'You have to enter the name to continue',
                    id: 'gift_msg.input.from.error'
                }),
                maxLength: {
                    message: formatMessage(generalMessages.maxLength, {
                        label: labelGiftFrom,
                        n: 80
                    }),
                    value: 80
                },
                minLength: {
                    message: formatMessage(generalMessages.minLength, {
                        label: labelGiftFrom,
                        n: 3
                    }),
                    value: 3
                }
            },
            error: errors[`giftFrom`],
            inputProps: {
                autoComplete: 'name'
            },
            control,
            inputCounterVisible: true,
            maxLength: 80
        },
        giftRecipientName: {
            name: `giftRecipientName`,
            label: labelRecipientName,
            placeholder: formatMessage({
                defaultMessage: 'Enter the recipient’s name',
                id: 'gift_msg.input.recipient.name.placeholder'
            }),
            type: 'text',
            defaultValue: '',
            rules: {
                maxLength: {
                    message: formatMessage(generalMessages.maxLength, {
                        label: labelRecipientName,
                        n: 80
                    }),
                    value: 80
                }
            },
            error: errors[`giftRecipientName`],
            inputProps: {
                autoComplete: 'name'
            },
            control,
            inputCounterVisible: true,
            maxLength: 80
        },
        giftRecipientEmail: {
            name: `giftRecipientEmail`,
            label: labelRecipientEmail,
            placeholder: formatMessage({
                defaultMessage: 'Enter the recipient’s email',
                id: 'gift_msg.input.recipient.email.placeholder'
            }),
            type: 'email',
            defaultValue: '',
            rules: {
                pattern: {
                    value: VALIDATE_EMAIL_PATTERN,
                    message: invalidEmailMessage
                },
                maxLength: {
                    message: formatMessage(generalMessages.maxLength, {
                        label: labelRecipientEmail,
                        n: 80
                    }),
                    value: 80
                }
            },
            error: errors[`giftRecipientEmail`],
            inputProps: {
                autoComplete: 'email'
            },
            control,
            inputCounterVisible: true,
            maxLength: 80,
            helpText: formatMessage({
                defaultMessage:
                    'The recipient will be notified that something special is coming their way. We will not inform them of the gift you chose.',
                id: 'gift_msg.input.recipient.email.helptext'
            }),
            helpTextInfoIcon: true
        }
    }
}
